export const constant = {
    // 利用者画面用のコンフィグファイル
    // WebAPI URL(1)
    BASE_API_URL_S: '/cs',
    // WebAPI URL(2)
    BASE_API_URL_P: '/cp',
    // ユーザープールID
    USER_POOL_ID: 'ap-northeast-1_2hyXJonmt',
    // クライアントID 通常ログイン用
    CLIENT_ID_1: '5crdsbingube9lupnurcq58dc2',
    // クライアントID SSOログイン用
    CLIENT_ID_2: '4k8e0gjbq5jseie109s9v46e2k',
    // CognitoでのSSOログイン用Key
    COGNITO_KEY: '1gnf52pmt8emcpoqk5o458tidc4lvjsl2o4n6fm6shaud49pspm0',
    // CognitoでのSSOリダイレクト先URL
    COGNITO_AUTH_URL: 'armcng-userpool-cmp01.auth.ap-northeast-1.amazoncognito.com',
    // CognitoサインアウトエンドポイントのURL
    COGNITO_SIGNOUT_ENDPOINT_URL: 'https://armcng-userpool-cmp01.auth.ap-northeast-1.amazoncognito.com/logout',
};
